import { render, staticRenderFns } from "./TableRiskAppraisalEp2.vue?vue&type=template&id=6622127a&scoped=true"
import script from "./TableRiskAppraisalEp2.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalEp2.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalEp2.vue?vue&type=style&index=0&id=6622127a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622127a",
  null
  
)

export default component.exports